import React from "react";
import {DevSubscribeForm} from "./DevSubscribeForm";

import {useACFOptions} from "../_hooks/useACFOptions";

export const DevSubscribe = ({number, color = 'purple'}) => {
  number = number || '04.';

  const { subscribe } = useACFOptions();

  const {suptitle, title, text} = subscribe;

  return (
    <div className="home-subscribe pb-lg-16 py-md-11 py-11" id="subscribe">
      <div className="container pb-lg-11">
        <div className="border border-1 news-widget">
          <div className="row align-items-xl-center  align-items-md-end d-flex flex-wrap">
            <div className="col-xl-8 col-lg-8 col-md-8 d-flex mobile-flex-wrap">
              <div className='me-4 d-flex align-items-start mt-5'>
                <span className={`zg-label bg-${color} text-black mb-2 d-inline-block`}>Subscribe</span>
              </div>
              <div className='d-flex flex-column'>
              <h2 className="h3 mb-5 mb-md-6 mt-3 mb-lg-3 letter-spacing-4 ">Developer Newsletter</h2>
                <p className="fs-7 mb-xl-0 mb-lg-4 mb-5">The growth of DeFi on Bitcoin just doesn't slow down. Get the latest updates from the 
Rootstock ecosystem.</p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 offset-xl-0">
              <DevSubscribeForm/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
